import React, { useEffect } from "react";
import Card from "./Card";
import { nanoid } from "nanoid";
import iconArray from "../iconList";
import Confetti from "react-confetti";
import { shuffle } from "../iconList";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


export default function Board(props) {
    const [boardArray, setBoardArray] = React.useState([])
    const [howManyLeft, setHowManyLeft] = React.useState()
    const [counter, setCounter] = React.useState(0)
    // Timer:
    const [timer, setTimer] = React.useState(0)

    const Timer = () => <div className={timerClass}>
        <div><FontAwesomeIcon icon="fa-solid fa-hand-pointer" /> {counter} </div>
        <div><FontAwesomeIcon icon="fa-solid fa-clock" /> {timer}s</div>
    </div>


    let howManySelected = boardArray.filter(card => card.selected === true).length
    let gameIsWon = howManyLeft === 2 ? true : false
    const timerClass = gameIsWon ? "timer selected" : "timer"

    /* ####################
            USE EFFECTs
       #################### */

    // Card selecting logic:

    useEffect(() => {
        if (howManySelected === 2) {
            const selected = boardArray.filter(card => card.selected === true)
            // if both selected icons are the same:
            if (selected[0].value.props.icon === selected[1].value.props.icon) {
                holdCard(selected[0].id)
                holdCard(selected[1].id)
                setHowManyLeft(boardArray.filter(card => card.held === false).length)
            } else {
            }
        } else if (howManySelected > 2) {
            unSelectCards()
        }
    }, [howManySelected, boardArray]
    )

    // Generating new board each new game

    useEffect(() => setBoardArray(newBoard(16)), [gameIsWon])
    useEffect(() => highScoreUpdate(), [gameIsWon])

    // Timer:

    useEffect(() => {
        let interval = null
        if (!gameIsWon) {
            interval = setInterval(() => { setTimer(time => time + 1) }, 1000)
        } else if (gameIsWon && timer !== 0) {
            clearInterval(interval)
        }
        return () => clearInterval(interval)
    }, [gameIsWon, timer])

    /* ####################
          FUNCTIONALITY
       #################### */

    function newBoard(size) {
        shuffle(iconArray)
        let array = []
        for (let i = 1; i <= size; i++) {
            array.push({
                id: nanoid(),
                selected: false,
                value: iconArray[i - 1],
                held: false
            })
        }
        return array
    }

    function holdCard(id) {
        setBoardArray(oldBoard => oldBoard.map(card =>
            card.id === id ? { ...card, held: true, selected: false } : card
        ))
    }

    function selectCard(id) {
        howManySelected < 2 && setCounter(prevCounter => prevCounter + 1)
        console.log(counter)
        if (gameIsWon === false) {
            setBoardArray(oldBoard => oldBoard.map(card => {
                if (card.id === id) {
                    return { ...card, selected: !card.selected }
                } else {
                    return card
                }
            }))
        } else {
            props.setInGame(false)
        }
    }


    function unSelectCards() {
        setBoardArray(oldBoard =>
            oldBoard.map(card =>
                card.selected ? { ...card, selected: false } : card)
        )
    }

    function highScoreUpdate() {
        // Check if there's any highscore set in local storage
        // var localHighscores - highscores in local storage
        const myHighScore = [counter, timer]
        let localHighscores = []
        if ("memory-highscore" in localStorage) {
            localHighscores = JSON.parse(localStorage.getItem("memory-highscore"))
            console.log("There is highscore")
        } else {
            localStorage.setItem("memory-highscore", JSON.stringify(localHighscores))
        }
        console.log(localHighscores)
       if (gameIsWon) {
            localHighscores.push(myHighScore)
            localStorage.setItem("memory-highscore", JSON.stringify(localHighscores))
       }

        // Map through highscore table and compare current highscore checking against timer+counter
        // Update highscore if it's lower than current one
    }

    function renderBoard() {
        return <div className="board--grid">
            {boardArray.map(card =>
                <Card
                    key={card.id}
                    id={card.id}
                    selected={card.selected}
                    value={card.value}
                    clickHandler={() => selectCard(card.id)}
                    held={card.held}
                />
            )}
        </div>
    }

    return (
        <div>
            {<Timer />}
            {gameIsWon && <Confetti />}
            {renderBoard()}
            <button className="back floating" onClick={() => props.setInGame(false)}>Back</button>
        </div>
    )
}